export enum WorkflowStatus {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  RESUME = 'RESUME',
  RETRY = 'RETRY',
  SUCCESS = 'SUCCESS',
  PAID = 'PAID',
  PAID_PARTIALLY = 'PAID_PARTIALLY',
}
